import React from 'react';

import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ServiceThemeOptions } from '../../themes';
import { ButtonWithText } from '../ButtonWithText';
import { onboardStyles } from '../ComponentStyles';

interface OnboardFooterProps {
  isFormValid: boolean;
  disableButton: boolean;
  tsp: string;
  primaryColor: string; // Keep for backward compatibility
  onHelpClick: () => void;
}

/**
 * Footer component for the onboarding page with submit button and help link
 */
const OnboardFooter: React.FC<OnboardFooterProps> = ({
  isFormValid,
  disableButton,
  tsp,
  primaryColor, // Still accept this prop for backward compatibility
  onHelpClick,
}) => {
  const theme = useTheme() as ServiceThemeOptions;

  // Determine button text based on TSP
  const getButtonText = () => {
    // if (['motive', 'samsara', 'zubie', 'bouncie'].includes(tsp)) return 'CONNECT'; // if we want to get specific
    return 'CONNECT TELEMATICS';
  };

  return (
    <Box sx={onboardStyles.footerContainer}>
      <ButtonWithText
        type='submit'
        form='onboarding-form'
        disabled={!isFormValid || disableButton}
        sx={onboardStyles.submitButton(isFormValid, theme as any)}
      >
        {getButtonText()}
      </ButtonWithText>

      <Button
        variant='text'
        onClick={onHelpClick}
        sx={onboardStyles.helpButton(theme as any)}
      >
        Need help getting connected?
      </Button>
    </Box>
  );
};

export default OnboardFooter;
